import gql from 'graphql-tag';

export class CntContributionItemDetailInput {
  id: number;
  contributionItemId: number;
  aa: number;
  qty1: number;
  qty2: number;
  qty3: number;
  price: number;

  constructor() {
    this.id = undefined;
    this.contributionItemId = undefined;
    this.aa = undefined;
    this.qty1 = undefined;
    this.qty2 = undefined;
    this.qty3 = undefined;
    this.price = undefined;
  }
}
export class ContributionItemInput {
  id: number;
  contributionId: number;
  aa: number;
  itemId: number;
  qty1: number;
  qty2: number;
  qty3: number;
  price: number;
  cntContributionItemDetails: [CntContributionItemDetailInput];

  constructor() {
    this.id = undefined;
    this.contributionId = undefined;
    this.aa = undefined;
    this.itemId = undefined;
    this.qty1 = undefined;
    this.qty2 = undefined;
    this.qty3 = undefined;
    this.price = undefined;
    this.cntContributionItemDetails = undefined;
  }
}
export class FormInput {
  id: number;
  contributorId: number;
  templateId: number;
  year: number;
  periodId: number;
  submittedByUser: string;
  declarationDate: Date;
  statusId: number;
  isInvoiced: boolean;
  releaseToErp: boolean;
  isCanceled: boolean;
  invoiceFileId: number;
  creditInvoiceFileId: number;
  totalCost: number;
  totalQty: number;
  totalWeight: number;
  userStringField1: string;
  userStringField2: string;
  userStringField3: string;
  userStringField4: string;
  userStringField5: string;
  userStringField6: string;
  userStringField7: string;
  userStringField8: string;
  userStringField9: string;
  userStringField10: string;
  seriesId: number;
  contributionItems: [ContributionItemInput];

  constructor() {
    this.id = undefined;
    this.contributorId = undefined;
    this.templateId = undefined;
    this.year = undefined;
    this.periodId = undefined;
    this.submittedByUser = undefined;
    this.declarationDate = undefined;
    this.statusId = undefined;
    this.isInvoiced = undefined;
    this.releaseToErp = undefined;
    this.isCanceled = undefined;
    this.invoiceFileId = undefined;
    this.creditInvoiceFileId = undefined;
    this.totalCost = undefined;
    this.totalQty = undefined;
    this.totalWeight = undefined;
    this.userStringField1 = undefined;
    this.userStringField2 = undefined;
    this.userStringField3 = undefined;
    this.userStringField4 = undefined;
    this.userStringField5 = undefined;
    this.userStringField6 = undefined;
    this.userStringField7 = undefined;
    this.userStringField8 = undefined;
    this.userStringField9 = undefined;
    this.userStringField10 = undefined;
    this.seriesId = undefined;
    this.contributionItems = undefined;
  }
}

export const gqlGetQuery = gql`
  query getCntContributions($limit: Int, $offset: Int, $order: String, $where: String) {
    getCntContributions(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        contributorId
        templateId
        year
        periodId
        submittedByUser
        declarationDate
        statusId
        isInvoiced
        releaseToErp
        isCanceled
        invoiceFileId
        totalCost
        totalCostWithVat
        totalQty
        totalWeight
        erpEntityCode
        erpEntityId
        contributor {
          id
          name
          addressLine1
          addressArea
          vatNumber
          taxOffice
        }
        contributionperiod {
          id
          name
          enName
          months
          periodStartDay
          periodStartMonth
          periodEndDay
          periodEndMonth
          periodEndYearAdd
          contributionsPeriodgroup {
            id
            name
          }
        }
        series {
          id
          name
          enName
        }
        contributionstate {
          id
          name
        }
        cntContributionSend2Erp {
          id
          # contributionId
          # submittedByUser
          # submittedDate
          # action
          # message
          # jsonsend
          # erpresult
        }
        invoiceFile {
          id
          fileName
        }
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getCntContributionById($id: Int) {
    getCntContributionById(id: $id) {
      id
      contributorId
      templateId
      year
      periodId
      submittedByUser
      declarationDate
      statusId
      isInvoiced
      releaseToErp
      isCanceled
      invoiceFileId
      creditInvoiceFileId
      totalCost
      totalCostWithVat
      totalQty
      totalWeight
      userStringField1
      userStringField2
      userStringField3
      userStringField4
      userStringField5
      userStringField6
      userStringField7
      userStringField8
      userStringField9
      userStringField10
      firstDate
      lastDate
      firstUser
      lastUser
      seriesId
      erpEntityCode
      erpEntityId
      contributor {
        id
        name
        addressLine1
        addressArea
        vatNumber
        taxOffice
        contributorGroupId
        cntContributorsGroup {
          id
          name
          enName
        }
      }
      invoiceFile {
        id
        fileName
        mimeMediaType
        s3Key
      }
      creditInvoiceFile {
        id
        fileName
        mimeMediaType
        s3Key
      }
      contributionperiod {
        id
        name
        months
        periodStartDay
        periodStartMonth
        periodEndDay
        periodEndMonth
        periodEndYearAdd
        contributionsPeriodgroup {
          id
          name
        }
      }
      series {
        id
        name
        enName
      }
      contributionstate {
        id
        name
      }
      contributionTemplate {
        id
        name
      }
      contributionItems {
        id
        aa
        itemId
        qty1
        qty2
        qty3
        price
        item {
          id
          name
          code
          footnote
          groupId
          subgroupId
          units1
          units2
          units3
          priceCalculationMethod
          hasDetails
          useInNonEdoe
          useInEdoe
          useInEdoeUsed
          group {
            id
            name
            enName
          }
          subgroup {
            id
            name
            enName
          }
          enName
          enFootnote
          enEmpaCategory
          enErpItemName
        }
        unitPrice {
          id
          unitPrice
          priceCalculationMethod
        }
        cntContributionItemDetails {
          id
          aa
          qty1
          qty2
          qty3
          price
        }
      }
    }
  }
`;

export const gqlAdd = gql`
  mutation addCntContribution($data: CntContributionInput) {
    addCntContribution(data: $data) {
      id
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateCntContribution($data: CntContributionInput) {
    updateCntContribution(data: $data) {
      id
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteCntContribution($id: Int) {
    deleteCntContribution(id: $id)
  }
`;

export const gqlCreateContributionsForCurrentYear = gql`
  mutation createContributionsForCurrentYear {
    createContributionsForCurrentYear
  }
`;
